module.exports = __webpack_public_path__ + "tables/media/light-dashboard.88f555d5.svg";